import BaseComponent from "../core/base-component.js";
import { scrollIntoView } from "seamless-scroll-polyfill";

interface ScrollToConfig {
    target?: string;
    offset?: number;
    behavior?: ScrollBehavior;
}

const DEFAULT_ELEMENT_SELECTOR: string = '[data-bs-toggle="scrollto"],[data-bs-toggle="anchor"]';

const defaultOptions: ScrollToConfig = {
    offset: 0,
    behavior: 'smooth'
};

class ScrollTo extends BaseComponent {
    protected options: ScrollToConfig = defaultOptions;
    protected isLoaded: boolean = false;
    protected targetElement: HTMLElement | null;

    public override init() {
        this.options = this.assignConfig<ScrollToConfig>(defaultOptions, this.config);
        const pageHeaderEl = document.querySelector<HTMLElement>('.th-page-header');
        if(pageHeaderEl) {
            const pageHeaderElStyles = window.getComputedStyle(pageHeaderEl);
            if(pageHeaderElStyles.position == 'fixed') {
                this.options.offset = pageHeaderEl.offsetHeight + 5;
            }
        }

        const targetSelector = this.options.target  ?? this.element.dataset['target'] ?? this.element.getAttribute('href') ?? '';
        if(targetSelector != '') {
            try {
                this.targetElement = document.querySelector<HTMLElement>(targetSelector);
                this.element.setAttribute('href', '#');
            } catch(ex) {
            }
        }
    }

    public override process() {
        if(this.targetElement) {
            this.element.addEventListener('click', (ev: MouseEvent) => {
                ev.preventDefault();
                ScrollTo.scrollTo(this.targetElement, this.options);
                return false;
            })
        }
    }

    public static scrollTo(elOrSelector: string|HTMLElement|null|undefined, options: ScrollToConfig|null = null): void {
        if(options == null) {
            options = defaultOptions;
        }
        if(typeof(elOrSelector) != undefined && elOrSelector != null) {
            let el: HTMLElement|null = null;
            if (elOrSelector instanceof HTMLElement) {
                el = elOrSelector
            } else if (typeof (elOrSelector) == 'string') {
                el = document.querySelector<HTMLElement>(elOrSelector);
            }

            if (el && el != null) {
                el.style.scrollMarginBlockStart = (options.offset || 0) + 'px';

                scrollIntoView(el, { behavior: options.behavior || 'auto', block: 'center', inline: 'center' });
            }
        }
    }

}

// Observe
ScrollTo.initializeDom(DEFAULT_ELEMENT_SELECTOR, true, false, true);

export type { ScrollToConfig };
export default ScrollTo;
